import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconBook = props => (
  <SvgIcon {...props} viewBox="0 0 22 17">
    <path fillRule="evenodd" d="m20 0.5c-1.11-0.35-2.33-0.5-3.5-0.5-1.95 0-4.05 0.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5s-4.05 0.4-5.5 1.5v14.65c0 0.25 0.25 0.5 0.5 0.5 0.1 0 0.15-0.05 0.25-0.05 1.35-0.65 3.3-1.1 4.75-1.1 1.95 0 4.05 0.4 5.5 1.5 1.35-0.85 3.8-1.5 5.5-1.5 1.65 0 3.35 0.3 4.75 1.05 0.1 0.05 0.15 0.05 0.25 0.05 0.25 0 0.5-0.25 0.5-0.5v-14.6c-0.6-0.45-1.25-0.75-2-1zm0 13.5c-1.1-0.35-2.3-0.5-3.5-0.5-1.7 0-4.15 0.65-5.5 1.5v-11.5c1.35-0.85 3.8-1.5 5.5-1.5 1.2 0 2.4 0.15 3.5 0.5v11.5z" />
  </SvgIcon>
);

export default IconBook;



// WEBPACK FOOTER //
// ./src/components/icons/IconBook.js